import { action } from 'app/actions';

export const EDIT_GROUP = 'classesStudents/edit/EDIT_GROUP';
export const ADD_GROUP = 'classesStudents/edit/ADD_GROUP';
export const GET_GROUP_INFORMATION = 'classesStudents/edit/GET_GROUP_INFORMATION';
export const GET_SCHOOLS = 'classesStudents/edit/GET_SCHOOLS';
export const GET_CLASSES = 'classesStudents/edit/GET_CLASSES';
export const GET_LEVELS = 'classesStudents/edit/GET_LEVELS';
export const GET_PERIODS = 'classesStudents/edit/GET_PERIODS';
export const NEW_GROUP = 'classesStudents/edit/NEW_GROUP';
export const ADD_STUDENT = 'classesStudents/ADD_STUDENT';
export const EDIT_STUDENT = 'classesStudents/EDIT_STUDENT';
export const DELETE_STUDENT = 'classesStudents/DELETE_STUDENT';
export const UNDO_DELETE_STUDENT = 'classesStudents/UNDO_DELETE_STUDENT';
export const REQUEST_EDIT_STUDENT = 'classesStudents/REQUEST_EDIT_STUDENT';
export const REQUEST_VIEW_STUDENT = 'classesStudents/REQUEST_VIEW_STUDENT';
export const GET_GROUPS = 'classesStudents/GET_GROUPS';

export const getGroupInformation = (payload) => action(GET_GROUP_INFORMATION, { payload });
export const editGroup = (payload) => action(EDIT_GROUP, { payload });
export const addGroup = (payload) => action(ADD_GROUP, { payload });
export const getLevels = (payload) => action(GET_LEVELS, { payload });
export const getClasses = (payload) => action(GET_CLASSES, { payload });
export const getPeriods = (payload) => action(GET_PERIODS, { payload });
export const getSchools = (payload) => action(GET_SCHOOLS, { payload });
export const addStudent = (payload) => action(ADD_STUDENT, { payload });
export const editStudent = (payload) => action(EDIT_STUDENT, { payload });
export const deleteStudent = (payload) => action(DELETE_STUDENT, { payload, meta: payload });
export const undoDeleteStudent = (payload) => action(UNDO_DELETE_STUDENT, { payload });
export const newGroup = () => action(NEW_GROUP);
export const requestEditStudent = (payload) => action(REQUEST_EDIT_STUDENT, { payload });
export const requestViewStudent = (payload) => action(REQUEST_VIEW_STUDENT, { payload });
export const getGroups = (payload) => action(GET_GROUPS, { payload });
